import React from 'react';
import { useSelector } from 'react-redux';

export default function useDataSourceSelector() {
  const DataSourceListData = useSelector((state) => state.DataSource.list_data) || []; // List data
  const DataSourceViewData = useSelector((state) => state.DataSource.view_data) || {}; // View
  const DataSourceValidateData = useSelector((state) => state.DataSource.validate_data) || {}; // View
  const DataSourceEdit = useSelector((state) => state.DataSource.edit_data) || {}; // edit
  const DataAgentList = useSelector((state) => state.DataSource.agent_list || []);

  // console.log('DataAgentList in selector', DataAgentList);
  // console.log('DataSourceList in selector', DataSourceListData);
  return {
    DataSourceListData,
    DataSourceViewData,
    DataSourceEdit,
    DataSourceValidateData,
    DataAgentList
  };
}
